<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Users'|translate }}
                </v-card-title>
                <v-card-actions>
                    <span style="width:300px;"><v-text-field class="ml-2" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="changePasswordDialog=true" :disabled="!$can('update','OwnUser')">
                        <v-icon small class="mr-2">fa-sync-alt</v-icon>
                        {{ 'Change Password'|translate }}
                    </v-btn>
                    <v-btn class="accent mr-2" @click="launchCreate()" :disabled="!$can('create','Users')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <user-record-dialog v-model="dialog" :item="editedItem"
                                        v-on:updatedusers="refresh()"></user-record-dialog>
                </v-card-actions>
                <change-password-dialog
                    v-model="changePasswordDialog"
                    :item="editedItem">
                </change-password-dialog>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="users"
                        :search="search2"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.user_id }}</td>
                            <td class="text-xs-left">{{ props.item.email }}</td>
                            <td class="text-xs-left">
                                {{ props.item.user_name }}
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.updated_on&&props.item.updated_on!=='NaT'">{{
                                        props.item.updated_on.substring(0, 10)
                                    }}</span>
                            </td>
                            <td class="text-xs-left">
                                <span v-if="props.item.created_on&&props.item.created_on!=='NaT'">{{
                                        props.item.created_on.substring(0, 10)
                                    }}</span>
                            </td>
                            <td class="text-xs-left">{{ roles[props.item.role] }}</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update','Users')"
                                    @click="$can('update','Users') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update','Users')&&props.item.two_factor_setup"
                                    @click="$can('update','Users') && resetAuthenticator(props.item)"
                                >
                                    fa-user-lock
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('delete','Users')"
                                    @click="$can('delete','Users') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import ChangePasswordDialog from '../components/users/ChangePasswordDialog'
import {getUser, deleteUser, resetUserAuthenticator} from '../helper'
import UserRecordDialog from '../components/users/UserRecordDialog'
import _ from 'lodash'

export default {
    name: 'Users',
    components: {UserRecordDialog, ChangePasswordDialog},
    data() {
        return {
            changePasswordDialog: false,
            dialog: false,
            search: '',
            search2: '',
            timeout: null,
            roles: {
                'admin': 'Administrator',
                'maintainer': 'Maintainer',
                'operator': 'Operator',
                'viewer': 'Viewer',
            },
            headers: [
                {
                    text: this.$options.filters.translate('User ID'),
                    align: 'left',
                    sortable: true,
                    value: 'user_id'
                },
                {text: this.$options.filters.translate('Email'), value: 'email'},
                {text: this.$options.filters.translate('User Name'), value: 'user_name'},
                {text: this.$options.filters.translate('Update On'), value: 'updated_on'},
                {text: this.$options.filters.translate('Created On'), value: 'created_on'},
                {text: this.$options.filters.translate('Role'), value: 'role'},
                {text: this.$options.filters.translate('Actions'), value: 'actions'},
            ],
            users: [
                {
                    'user_id': 1,
                    'email': 'email',
                    'user_name': 'username',
                    'updated_on': '2019-01-01',
                    'created_on': '2019-01-01',
                    'role': 'admin'
                },
            ],
            editedIndex: -1,
            editedItem: {},
        }
    },
    watch: {
        changePasswordDialog() {
            this.editedItem = Object.assign({}, this.currentUserItem)
        },
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    computed: {
        currentUserItem() {
            let self = this
            return _.filter(this.users, function (x) {
                return (x.user_name == self.$store.state.userStore.user.content.user_name)
            })[0]
        }
    },
    mounted() {
        this.initialize()
    },
    methods: {
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        launchCreate() {
            this.editedItem = null;
            this.dialog = true
        },
        initialize() {
            this.refresh()
        },

        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },

        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteUser({
                    'user_id': item.user_id
                })
                this.refresh()
            }
        },
        async resetAuthenticator(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to reset the authenticator for this user?'))) {
                await resetUserAuthenticator({
                    'user_id': item.user_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getUser({})
            this.users = df['users']
        }
    }
}
</script>

<style scoped>

</style>

